import { render, staticRenderFns } from "./ActivityCard.vue?vue&type=template&id=3af50268"
import script from "./ActivityCard.vue?vue&type=script&lang=js"
export * from "./ActivityCard.vue?vue&type=script&lang=js"
import style0 from "./ActivityCard.vue?vue&type=style&index=0&id=3af50268&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports